import type { ComponentProps } from 'react';

import { cn } from '../../lib/cn';
import {
  Toggle as PrimitiveToggle,
  toggleVariants as primitiveToggleVariants,
} from '../../primitive/toggle';

export function toggleVariants({
  class: classValue,
  className,
  ...variants
}: NonNullable<Parameters<typeof primitiveToggleVariants>[0]> = {}) {
  return cn(primitiveToggleVariants(variants), 'text-[13px]', classValue, className);
}

export function Toggle({ className, ...props }: ComponentProps<typeof PrimitiveToggle>) {
  return <PrimitiveToggle className={cn('text-[13px]', className)} {...props} />;
}
